import React from 'react';
import { AppleIDSignInOnFailure, AppleIDSignInOnSuccess } from 'apple-signin-react';
import { useAppDispatch } from 'app/hooks';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import useUserDetail from 'hooks/useUserDetail';
import authApi from 'api/auth';
import { setLocalStorage } from 'utils/sessionStorage';
import { onChangeAuthPage } from 'features/home/homeSlice';
import env from 'app/env';
import AppleSignin from 'react-apple-signin-auth';
import { JSX } from 'react/jsx-runtime';
import apple_icon from 'assets/icons/icon_apple_logo_dark.png';
import apple_white_icon from 'assets/icons/apple_white_logo.png';
interface AppleAuthProps {}

const AppleAuth: React.FunctionComponent<AppleAuthProps> = () => {
  const dispatch = useAppDispatch();
  const handleResponseError = useHandleResponseError();
  const { getUserDetail } = useUserDetail();

  const handleError = (error: AppleIDSignInOnFailure) => {
    console.log(error);
  };

  const handelSuccess = async (data: AppleIDSignInOnSuccess) => {
    if (data) {
      const { ok, error, body } = await authApi.appleLogin({
        idToken: data.authorization?.id_token,
        code: data.authorization?.code,
        firstName: data.user ? data.user.name.firstName : '',
        lastName: data.user ? data.user.name.lastName : '',
      });
      if (ok && body) {
        setLocalStorage('access_token_terabet', body.accessToken);
        dispatch(onChangeAuthPage(-1));
      }
      if (error) {
        handleResponseError(error);
      }
      getUserDetail();
    }
  };
  return (
    <AppleSignin
      authOptions={{
        clientId: `${env.appleClientId}`,
        scope: 'email name',
        redirectURI: `${env.appleRedirectUri}`,
        state: 'state',
        nonce: 'nonce',
        usePopup: true,
      }}
      uiType="light"
      className="btn-sso apple-sso"
      noDefaultStyle={true}
      buttonExtraChildren="Continue with Apple"
      onSuccess={handelSuccess}
      onError={handleError}
      skipScript={false}
      render={(
        props: JSX.IntrinsicAttributes &
          React.ClassAttributes<HTMLDivElement> &
          React.HTMLAttributes<HTMLDivElement>,
      ) => (
        <div {...props} role="button" tabIndex={0}>
          <img src={apple_white_icon} alt="apple" className="social-login-button" />
        </div>
      )}
    />
  );
};

export default AppleAuth;
